module.exports = __webpack_public_path__ + "static/assets/f07940f6aa2c8522a89ce7c100fbc3d9.svg";